import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';

export type OutlookOauthCode = {
  code: string;
};

const outlookAuthCallback = (data: OutlookOauthCode) => {
  const request: Request = {
    url: ENDPOINTS.outlook.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  return client(request);
};

const useOutlookAuthCallback = () =>
  useMutation<Response<null>, CronoError, OutlookOauthCode>(
    outlookAuthCallback,
    {
      meta: {
        successMessage: 'Successfully logged into Outlook',
        errorMessage: 'Error while connecting with Outlook',
      },
    },
  );

export default useOutlookAuthCallback;
